// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"FeatureListPagination_paginationContainer__9lDzC","leftToRight":"FeatureListPagination_leftToRight__CqkYn"};